import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { generateOtpResetPasswordActions } from "redux/actions/auth/ResetPassword/generateOtpResetPasswordActions";
import { useTranslation } from "react-i18next";

interface generateOtpTypes {
  countryCode: string;
  phone: string;
  email: string;
}

export const useGenerateOtpResetPasswordFormik = (
  resetPasswordMethod: any,
  country: any,
  setResetPop: any,
  setPhoneNum: any,
  setEmail: any,
  setCountryCode: any
) => {
  const dispatch: any = useDispatch();
  const { i18n, t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      countryCode: "",
      phone: "",
      email: "",
    },
    validationSchema: yup.object({
      phone:
        resetPasswordMethod === 1
          ? country === "eg"
            ? yup
                .string()
                .matches(
                  /^(?:\+20)?(?:\+0)?(10|11|12|15)\d{8}$/,
                  `${t("Invalid phone number")}`
                )
                .required(`${t("This field is required")}`)
            : country === "uae"
            ? yup
                .string()
                .matches(
                  /^(?:\+971|0)?(50|55|56|52|58)\d{7}$/,
                  `${t("Invalid phone number")}`
                )
                .required(`${t("This field is required")}`)
            : yup.string().required(`${t("This field is required")}`)
          : country === "eg"
          ? yup
              .string()
              .matches(
                /^(?:\+20)?(?:\+0)?(10|11|12|15)\d{8}$/,
                `${t("Invalid phone number")}`
              )
          : country === "uae"
          ? yup
              .string()
              .matches(
                /^(?:\+971|0)?(50|55|56|52|58)\d{7}$/,
                `${t("Invalid phone number")}`
              )
              .required(`${t("This field is required")}`)
          : yup.string(),

      email:
        resetPasswordMethod === 1
          ? yup.string().email()
          : yup
              .string()
              .email(`${t("email must be a valid email")}`)
              .required(`${t("This field is required")}`),
    }),
    onSubmit: async (values: generateOtpTypes) => {
      await dispatch(
        generateOtpResetPasswordActions(
          resetPasswordMethod === 1
            ? {
                screen: "app_password_reset", //static value
                lang: `${i18n.language}`, // app language ar or en
                country_code: formik.values.countryCode,
                phone_number: formik.values.phone,
                device: "web", // static
              }
            : {
                screen: "app_password_reset", //static value
                lang: `${i18n.language}`, // app language ar or en
                email: formik.values.email, // user registered email
                device: "web", // static
              },

          () => {
            setResetPop("validateOtpResetPassword");
            setCountryCode(values.countryCode);
            setPhoneNum(values.phone);
            setEmail(values.email);
          }
        )
      );
    },
  });

  return formik;
};
